export default "__VITE_ASSET__ClMZR5x1__"